import { useEffect, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import ApiDatabase from '../../../../../../server';
import { formatBirthday } from './dateUtils';

/**
 * Hook pour charger les données du tempWorker et de l'utilisateur
 * @param {object} params
 * @param {string} params.token - Token d'authentification
 * @param {string} params.adminTempWorkerId - ID du tempWorker
 * @param {boolean} params.enabled - Activer le chargement (défaut: true)
 * @returns {object} { tempWorker, user, isLoading }
 */
const useAdminModalTempWorker = ({ 
  token, 
  adminTempWorkerId, 
  enabled = true 
}) => {
  const [tempWorker, setTempWorker] = useState({});
  const [user, setUser] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = useCallback(() => {
    if (!token || !adminTempWorkerId) {
      setTempWorker({});
      setUser({});
      setIsLoading(false);
      toast.error('Une erreur est survenue, veuillez réessayer ou contacter le support');
      return;
    }

    setIsLoading(true);

    ApiDatabase.getTempWorkerById(
      { token, adminTempWorkerId },
      (tempWorkerData) => {
        setTempWorker(tempWorkerData);

        const id_user = tempWorkerData.id_user;
        ApiDatabase.getUserById(
          { token, id_user },
          (userData) => {
            setUser({
              ...userData,
              birthday: formatBirthday(userData.birthday),
            });
            setIsLoading(false);
          },
          (err) => {
            if (err.name !== 'CanceledError') {
              console.log(err);
            }
            setIsLoading(false);
          }
        );
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.log(err);
        }
        setTempWorker({});
        setUser({});
        setIsLoading(false);
      }
    );
  }, [token, adminTempWorkerId]);

  useEffect(() => {
    if (enabled) {
      fetchData();
    }
  }, [enabled, fetchData]);

  return { tempWorker, user, isLoading, refetch: fetchData };
};

export default useAdminModalTempWorker;
